import type { PasteParagraphStyle } from './types/paste-paragraph-style'

// Paragraph-level formatting (alignment, spacing, indentation, drop cap) for a larry→larry copy,
// JSON-serialised onto the FIRST run span of each copied paragraph (WMPCM-10131 Issue 2).
//
// On a span rather than a wrapper block on purpose: the outbound `text/html` keeps exactly the
// structure external editors already receive, so pasting into Word is unchanged — an unknown
// `data-*` attribute is inert everywhere except here.
//
// One JSON attribute rather than one attribute per field so the write and read stay a single
// symmetric pair. `Paragraph` grows fields over time, and the per-field spelling is how a reader
// silently stops recovering one of them.
export const PASTE_PARA_STYLE_ATTR = 'data-paste-para-style'

export function writeParagraphStyleAttr(el: Element, para: PasteParagraphStyle | undefined): void {
  if (!para) return
  const entries = Object.entries(para).filter(([, v]) => v !== undefined)

  if (entries.length === 0) return
  el.setAttribute(PASTE_PARA_STYLE_ATTR, JSON.stringify(Object.fromEntries(entries)))
}

export function readParagraphStyleAttr(el: Element): PasteParagraphStyle | undefined {
  const raw = el.getAttribute(PASTE_PARA_STYLE_ATTR)

  if (!raw) return undefined

  try {
    const parsed: unknown = JSON.parse(raw)

    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as PasteParagraphStyle
    }
  } catch {
    // Malformed attribute — fall back to the destination's paragraph settings, which is exactly
    // the pre-WMPCM-10131 behaviour and never worse than it.
  }

  return undefined
}
